import { isObject, isArray, isUndefined } from './isDefined';
import Optional from './optional';

const PHONE_NUMBER_KEYS = [
  'resources-phone-numbers-primary',
  'resources-phone-numbers-extra-1',
  'resources-phone-numbers-extra-2',
  'resources-phone-numbers-extra-3'
];

const findIccFromSub = (subscription, number) => {
  if (!isObject(subscription) || !isArray(subscription?.features)) {
    return void 0;
  }

  for (const feature of subscription.features) {
    const featureAttributes = feature?.featureAttributes;

    if (!isArray(featureAttributes)) {
      continue;
    }

    const phoneNumberAttribute = featureAttributes.find(
      attribute =>
        PHONE_NUMBER_KEYS.includes(attribute?.key) &&
        attribute?.value === number
    );

    if (isUndefined(phoneNumberAttribute)) {
      continue;
    }

    const simCardKey = phoneNumberAttribute.key.replace(
      'phone-numbers',
      'sim-cards'
    );

    const simCardAttribute = featureAttributes.find(
      attribute => attribute?.key === simCardKey
    );
    return Optional(simCardAttribute?.value).or(void 0);
  }

  return void 0;
};

export default findIccFromSub;
